export const cookieUtil = {
  clearCookie (cname) {
    const name = cname + '='
    const ca = document.cookie.split(';')
    let cookieStr = ''
    for (let i = 0; i < ca.length; i++) {
      const c = ca[i].trim()
      if (c.indexOf(name) === 0) {
        document.cookie = c + ';expires=' + new Date(0).toUTCString() + ';path=/'
      } else {
        cookieStr += c
        cookieStr += ';'
      }
      document.cookie = cookieStr
    }
  },
  setCookie (cname, cvalue, exdays = 1) {
    const d = new Date()
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
    const expires = 'expires=' + d.toGMTString()
    document.cookie = cname + '=' + cvalue + '; ' + expires
  },
  getCookie (cname) {
    const name = cname + '='
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      const c = ca[i].trim()
      if (c.indexOf(name) !== -1) return c.substring(name.length, c.length)
    }
    return ''
  }
}
